angular.isUndefinedOrNull = function (val: $TSFixMe) {
    return angular.isUndefined(val) || val === null;
};

const httpStatus = {
    OK: 200,
    NotAcceptable: 406,
    Conflict: 409,
    PreconditionFailed: 412,
    ExpectationFailed: 417
} as const;

(window as any).HttpStatus = Object.freeze(httpStatus);

declare global {
    const HttpStatus: {
        OK: 200;
        NotAcceptable: 406;
        Conflict: 409;
        PreconditionFailed: 412;
        ExpectationFailed: 417;
    };
}

export function stripClasses<T>(value: T): T {
    if (Array.isArray(value)) {
        return value.map(stripClasses) as T;
    }

    if (value !== null && typeof value === "object" && !(value instanceof Date) && !(value instanceof RegExp)) {
        const plain: Record<string, unknown> = {};
        for (const key of Object.keys(value)) {
            plain[key] = stripClasses(value[key as keyof typeof value]);
        }
        return plain as T;
    }

    return value;
}
